import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const GUEST_TOKEN_KEY = "vs_guest_token";
export const ADMIN_TOKEN_KEY = "vs_admin_token";

export const api = axios.create({ baseURL: API });

// Attach the appropriate token. Admin endpoints use the admin token,
// everything else falls back to the guest token.
api.interceptors.request.use((config) => {
  const url = config.url || "";
  const isAdmin = url.includes("/admin") || url.includes("/auth/");
  const token = isAdmin
    ? localStorage.getItem(ADMIN_TOKEN_KEY)
    : localStorage.getItem(GUEST_TOKEN_KEY) || localStorage.getItem(ADMIN_TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
